import React from 'react'
import styled from 'styled-components'
import Circle from '~/components/Circle'
import Text, { FontStyle } from '~/components/core/Text'
import FillSlider from '~/components/FillSlider'
import { light } from '~/constants/theme'
import { CallTranscript } from '~/types/CallTranscript'
import { convertCallDuration } from '~/utils/formatter'

interface HoldTimeAndPausesStatWrapperProps {
  width: number
  margin?: string
}

const HoldTimeAndPausesStatWrapper = styled.div<HoldTimeAndPausesStatWrapperProps>`
  display: flex;
  flex-direction: column;
  width: ${(props) => props.width}px;
  margin: ${(props) => props.margin ?? ''};
`

const StatsWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  height: 15px;
  margin-bottom: 1px;
`

interface HoldTimeAndPausesStatProps {
  transcript: CallTranscript
  width?: number
  margin?: string
}

const HoldTimeAndPausesStat = ({
  transcript,
  width,
  margin,
}: HoldTimeAndPausesStatProps) => {
  const holdTimeSeconds =
    (transcript.ConversationCharacteristics.NonTalkTime.TotalTimeMillis /
      1000) |
    0

  const callDurationSeconds =
    (transcript.ConversationCharacteristics.TotalConversationDurationMillis /
      1000) |
    0

  const percentageOfCall = holdTimeSeconds / callDurationSeconds

  const happyColor = light.dark300
  const sadColor = light.red100

  const holdTimeColor = percentageOfCall < 0.2 ? happyColor : sadColor
  return (
    <HoldTimeAndPausesStatWrapper width={width ?? 300} margin={margin}>
      <Text fontStyle={FontStyle.ButtonBold}>Hold Time and Pauses</Text>
      <FillSlider
        height={14}
        width={width ?? 300}
        fillPercentage={percentageOfCall}
        fillColor={holdTimeColor}
        fillOutline={`1px solid ${light.gray200}`}
        backgroundColor={light.gray300}
        border={`1px solid ${light.gray500}`}
        borderRadius={4}
        margin="4px 0px 3px 0px"
        animate
      />
      <StatsWrapper>
        <Circle radius={6} color={holdTimeColor} margin="0px 5px 0px 0px" />
        <Text fontStyle={FontStyle.TinySmall}>
          {convertCallDuration(holdTimeSeconds)} (
          {Math.round(percentageOfCall * 100).toFixed(0)}% of call)
        </Text>
      </StatsWrapper>
    </HoldTimeAndPausesStatWrapper>
  )
}

export default HoldTimeAndPausesStat
